var map = {
	"./modules/about/about.module": [
		"./src/app/modules/about/about.module.ts",
		"about.module"
	],
	"./modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"auth.module"
	],
	"./modules/batches/batches.module": [
		"./src/app/modules/batches/batches.module.ts",
		"batches.module"
	],
	"./modules/finance/finance.module": [
		"./src/app/modules/finance/finance.module.ts",
		"finance.module"
	],
	"./modules/import/import.module": [
		"./src/app/modules/import/import.module.ts",
		"import.module"
	],
	"./modules/inventory/inventory.module": [
		"./src/app/modules/inventory/inventory.module.ts",
		"inventory.module"
	],
	"./modules/operation/operation.module": [
		"./src/app/modules/operation/operation.module.ts",
		"operation.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main